import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import metaSlice from "../api/metaSlice"

const { actions } = metaSlice

/**
 * load website meta when starting SPA
 * @returns {*}
 */
export default function useEnvironment() {
  const dispatch = useDispatch()
  const env = useSelector((state) => state.website.env)

  useEffect(() => {
    if (!env.meta) {
      // init only at first time
      // otherwise reuse app state values
      dispatch(actions.fetchWebsiteMeta())
    }
  }, [dispatch, env])

  return env
}
